import { axios } from '@/utils/request'


/**
 * 处方退药列表
 *
 * @author zhangjw
 * @date 2023-09-14 17:23:21
 */
export function buRecipeReturnDrugList (parameter) {
  return axios({
    url: '/buRecipeReturnDrug/list',
    method: 'get',
    params: parameter
  })
}

/**
 * 添加处方退药
 *
 * @author zhangjw
 * @date 2023-09-14 17:23:21
 */
export function buRecipeReturnDrugAdd (parameter) {
  return axios({
    url: '/buRecipeReturnDrug/add',
    method: 'post',
    data: parameter
  })
}

/**
 * 编辑处方退药
 *
 * @author zhangjw
 * @date 2023-09-14 17:23:21
 */
export function buRecipeReturnDrugEdit (parameter) {
  return axios({
    url: '/buRecipeReturnDrug/edit',
    method: 'post',
    data: parameter
  })
}

/**
 * 删除处方退药
 *
 * @author zhangjw
 * @date 2023-09-14 17:23:21
 */
export function buRecipeReturnDrugDelete (parameter) {
  return axios({
    url: '/buRecipeReturnDrug/delete',
    method: 'post',
    data: parameter
  })
}

/**
 * 导出处方退药
 *
 * @author zhangjw
 * @date 2023-09-14 17:23:21
 */
export function buRecipeReturnDrugExport (parameter) {
  return axios({
    url: '/buRecipeReturnDrug/export',
    method: 'get',
    params: parameter,
    responseType: 'blob'
  })
}



/**
 * 查询处方退药
 *
 * @author zhangjw
 * @date 2023-09-14 17:23:21
 */
export function recipeReturnDrugPage (parameter) {
  return axios({
    url: '/recipeReturnDrug/page',
    method: 'get',
    params: parameter
  })
}


/**
 * 获取退药处方详情
 *
 * @author LIWEI
 * @date 2022-04-07 14:16:06
 */
export function recipeReturnDrugDetial (parameter) {
  return axios({
    url: '/recipeReturnDrug/detail',
    method: 'get',
    params: parameter
  })
}

/**
 * 审核通过/驳回
 *
 * @author 张禹尧
 * @date 2022-04-15 09:33:15
 */
export function recipeReturnDrugVerify (parameter) {
  return axios({
    url: '/recipeReturnDrug/verify',
    method: 'post',
    data: parameter
  })
}

/**
 * 确认退药
 *
 * @author zhangjw
 * @date 2023-09-14 17:23:21
 */
export function recipeReturnDrugRefund (parameter) {
  return axios({
    url: '/recipeReturnDrug/refund',
    method: 'post',
    params: parameter
  })
}


